import { NavigationLink } from "@atoms/index"

import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from "@constants/urls"

import styles from "./AuthDisclaimer.module.scss"

export default function AuthDisclaimerBase() {
    return (
        <div className={styles.base}>
            By using Roopairs, you agree to our{" "}
            <NavigationLink openIn="newTab" path={TERMS_OF_SERVICE_URL} isUnderLine={true} className={styles.link}>
                {() => "Terms of Service"}
            </NavigationLink>{" "}
            and{" "}
            <NavigationLink openIn="newTab" path={PRIVACY_POLICY_URL} isUnderLine={true} className={styles.link}>
                {() => "Privacy Policy"}
            </NavigationLink>
            .
        </div>
    )
}
